export const findNotRequiredErrors = (fieldsValidation, requiredMessages) =>
    fieldsValidation?.map((item) => {
        let showError = false;
        const errorMessages = requiredMessages.map(error => error.requiredMessage);

        if (item.value && item.errorMessage !== undefined) {
            showError = !errorMessages.includes(item.errorMessage);
        }

        return {
            name: item.name,
            showError
        };
    });

export const findAllRequiredErrors = (fieldsValidation, requiredMessages) =>
    fieldsValidation?.map((item, index) => {
        let showError = false;
        const errorMessages = requiredMessages.map(error => error.requiredMessage);
        const message = requiredMessages.find(el => el.name === item.name)?.requiredMessage;

        if (!item.value && item.errorMessage !== undefined && errorMessages.includes(item.errorMessage)) {
            const requiredFieldErrorIndex = fieldsValidation.findIndex(el => el.errorMessage === message);
            showError = index === requiredFieldErrorIndex;
        }

        return {
            name: item.name,
            showError
        };
    });
